import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';

export class ReportCardGradesTerm {
    Id: number;
    TermGradesDetailTypeId: number;
    TermDefinitionId: number;
    GradingTerm: string;
    GradingTermDescription: string;
    Grade: string;
    GradeDescription: string;
    SSEC_ID: number;
    CustomOrder: number;
    CreditEarned: number;
    CreditAttempted: number;
    PercentGrade: string;
    Comment: string;
    Citizenship: string;
    CitizenshipLabel: string;
    Workhabits: string;
    DisplayGrade: string;
    IsGradeBookGrade: boolean;
    V10Flag: boolean;
    AY_ID: number;
    IsGradeBookExists: boolean;
    DisplayCategoryScores: boolean;
    IsStandardGradebook: boolean;
    SchoolName: string;
    OverrideGradingTerm: string;
}

export class ReportCardGradesStandards {
    Id: number;
    StandardId: number;
    Standard: string;
    Level: number;
    SortBy: string;
    SSEC_ID: number;
    ReportCardGradesTerms: ReportCardGradesTerm[];
}

export class CurriculumMarkTypes {
    Id: number;
    Code: string;
    Description: string;
    InActive: boolean;
    ImportValue: number;

    // Non DTO Field
    isGridSelected: boolean;
}

export class GradesData {
    SiteYearId: number;
    SchoolName: string;
    Terms: ReportCardGradesTerm[];
    AngularMatData: TylerMatTableDataSource;
}

export class GradesPreferences {
    ShowProgressGrades: boolean;
}

export class CategoryAverage {
    SSEC_ID: number;
    CategoryName: string;
    CategoryAverage: number;
    CategoryWeight: number;
    TermId: number;
    TermName: string;
}

export class GradesBehaviorSocialSkills {
    SiteYearId: number;
    SchoolName: string;
    behaviorSocialSkillDescription: string;
}
